import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	viewProfile: {
		id: 'team-profile-card.team-actions.view-profile',
		defaultMessage: 'View profile',
		description: 'View profile button text',
	},
	giveKudos: {
		id: 'team-profile-card.team-actions.give-kudos',
		defaultMessage: 'Give kudos',
		description: 'Give kudos button text',
	},
});
